import { useState, useMemo, useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'

import { getAgenticPrompts } from 'services/agenticPrompts'
import { AGENTIC_PROMPT_SCOPES } from 'constants/agenticPrompts'
import debounce from 'utils/debounce'

const defaultFilters = {
  term: null,
  categories: null,
  scope: AGENTIC_PROMPT_SCOPES.ALL,
}

export const AGENTIC_PROMPTS_QUERY_KEY = 'agenticPromptsQuery'

function useAgenticPrompts(initialFilters = {}) {
  const [filters, setFilters] = useState({ ...defaultFilters, ...initialFilters })

  const { isLoading, data } = useQuery(
    [AGENTIC_PROMPTS_QUERY_KEY, filters],
    () => getAgenticPrompts(filters),
    {
      refetchOnWindowFocus: false,
      useErrorBoundary: true,
      structuralSharing: false,
    },
  )

  const debouncedSetTerm = useMemo(
    () => debounce(term => setFilters(prev => ({ ...prev, term })), 300),
    [],
  )

  const handleSearch = useCallback(
    event => {
      const term = event.target.value || null
      debouncedSetTerm(term)
    },
    [debouncedSetTerm],
  )

  function handleCategoriesChange(categories) {
    setFilters(prev => ({
      ...prev,
      categories: categories?.length ? categories : null,
    }))
  }

  return {
    prompts: data?.data ?? [],
    filters,
    isLoading,
    handleSearch,
    handleCategoriesChange,
  }
}

export { useAgenticPrompts }
